/* eslint-disable */
document.addEventListener('wpcf7mailsent', function (event) {
    switch (parseInt(event.detail.contactFormId)) {

        // nieuwsbrief formulier NL
        case 396:

          window.location.href = 'https://dutchsearchawards.nl/bedankt-nieuwsbrief/'
            break;

        // nieuwsbrief formulier EN
        case 482:

          window.location.href = 'https://dutchsearchawards.nl/en/thankyou-newsletter/'
            break;

        // inzendcriteria NL
        case 504:

          window.location.href = 'https://dutchsearchawards.nl/bedankt-inzendcriteria/'
          break;

        // inzendcriteria EN
        case 717:

          window.location.href = 'https://dutchsearchawards.nl/en/thankyou-submissioncriteria/'
            break;

        // jury formulier EN
        case 563:

          window.location.href = 'https://dutchsearchawards.nl/en/thankyou-jury/'
        break;

        // jury formulier NL
        case 513:

          window.location.href = 'https://dutchsearchawards.nl/bedankt-jury/'
            break;

        default:
            return;
    }
});



// WEBPACK FOOTER //
// ./scripts/modules/forms.js